import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ILoginCustomization, SessionService } from 'pod-ng-core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
})
export class ResetPasswordComponent implements OnInit {
  public model: any;
  public submitting = false;
  public environment = environment;

  private oLoginCustomization: Observable<ILoginCustomization>;
  public loginCustomization: ILoginCustomization;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastrService: ToastrService,
    private translateService: TranslateService,
    private session: SessionService
  ) {
    this.oLoginCustomization = this.activatedRoute.data?.pipe(
      pluck('loginCustomization')
    );

    if (this.oLoginCustomization) {
      this.oLoginCustomization.subscribe(data => {
        console.log('data', data);
        this.loginCustomization = data;
      });
    }
  }

  ngOnInit() {
    this.model = {};
  }

  // See https://github.com/DethAriel/ng-recaptcha for recaptcha
  public resetPass(form: NgForm) {
    if (form.valid) {
      this.submitting = true;
      this.session
        .resetPassword(
          this.model.email,
          this.model.captcha,
          this.loginCustomization?.whitelabel
        )
        .subscribe({
          next: result => {
            this.toastrService.success(
              this.translateService.instant('message.receiveNewPasswordEmail')
            );
            this.router.navigate(['..']);
            this.submitting = false;
          },
          error: () => {
            this.submitting = false;
          },
        });
    }
  }
}
